"use strict";

var _interopRequireWildcard = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportExcel = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _fileSaver = require("file-saver");
var Excel = _interopRequireWildcard(require("exceljs"));
var _index = require("@/utils/index");
var _string = require("@/utils/string");
var _moment = _interopRequireDefault(require("moment"));
var fontBold = {
  font: {
    bold: true
  }
};
var fontBoldRed = {
  font: {
    bold: true,
    color: {
      argb: "ffff0202"
    }
  }
};
var fontBoldGreen = {
  font: {
    bold: true,
    color: {
      argb: "ff427c27"
    }
  }
};
var border = {
  top: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  left: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  bottom: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  right: {
    style: "thin",
    color: {
      argb: "#000"
    }
  }
};
var row = 0;
var exportExcel = exports.exportExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var data, form, shipper, date, fileName, workbook, worksheet, startTableRow, startTable, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _ref.data, form = _ref.form;
          // config export excel
          shipper = '';
          if (form.shippers) {
            shipper = form.shippers.map(function (e) {
              return e.name;
            }).join("-");
          }
          date = (0, _moment.default)().format("DD/MM/YYYY hh:mm:s");
          fileName = "\u0110\u1ED1i so\xE1t ".concat(shipper, " ").concat(date);
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Đối soát", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            },
            views: [{
              state: 'frozen',
              ySplit: 2
            }]
          }); //add table
          startTableRow = 0;
          startTable = worksheet.getCell("A".concat(startTableRow++));
          startTable.style = {
            font: {
              color: {
                argb: "ffff0202"
              }
            }
          };
          generateTable(worksheet, data, startTableRow);
          _context.next = 13;
          return workbook.xlsx.writeBuffer();
        case 13:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function exportExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var generateTable = function generateTable(worksheet, data, startTableRow) {
  var orders = [];
  data.forEach(function (e) {
    e.id = e.orderId || e.id;
    e.moneyReturnShop = e.calcTotalMoney - e.shipFee;
    e.shipFee = +e.shipFee;
    e.customerShipFee = +e.customerShipFee;
    orders.push(e);
  });
  var startRow = startTableRow;
  var dataExcel = [{
    value: "ID đơn hàng",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "id",
    width: 20,
    mergeRow: true
  }, {
    value: "Ph\xED v\u1EADn chuy\u1EC3n h\xE3ng v\u1EADn chuy\u1EC3n thu ",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "shipFee",
    numFmt: '_(* #,##0_);_(* (#,##0);_(* "-"??_);_(@_)',
    width: 20,
    mergeRow: true
  }, {
    value: "Phí thu của khách",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "customerShipFee",
    numFmt: '_(* #,##0_);_(* (#,##0);_(* "-"??_);_(@_)',
    width: 12,
    mergeRow: true
  }, {
    value: " Tiền COD hãng vận chuyển trả    ",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "calcTotalMoney",
    numFmt: '_(* #,##0_);_(* (#,##0);_(* "-"??_);_(@_)',
    width: 12,
    mergeRow: true
  }];
  var char = "A";
  dataExcel.forEach(function (element) {
    var style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'ffff01'
        },
        bgColor: {
          argb: 'ffff01'
        }
      },
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    worksheet.getCell("".concat(char).concat(startRow)).style = style;
    worksheet.getCell("".concat(char).concat(startRow)).value = element.value;
    worksheet.getRow(startRow).height = 50;
    row = startRow + 1;
    orders.forEach(function (order, index) {
      var rowIndex = startRow + index + 1;
      worksheet.getRow(rowIndex).height = 50;
      worksheet.getCell("".concat(char).concat(rowIndex)).style = {
        border: border,
        alignment: {
          wrapText: true,
          vertical: 'middle'
        }
      };
      element.numFmt && (worksheet.getCell("".concat(char).concat(rowIndex)).numFmt = element.numFmt);
      var value = (0, _index.generateProp)(order, element.prop);
      if (element.mergeRow && order.rowspan) {
        worksheet.mergeCells("".concat(char).concat(rowIndex, ":").concat(char).concat(rowIndex - 1 + order.rowspan));
      }
      worksheet.getCell("".concat(char).concat(rowIndex)).value = value;
      row = rowIndex;
    });
    char = (0, _string.nextChar)(char);
  });
  worksheet.columns.forEach(function (e, i) {
    if (dataExcel[i]) e.width = dataExcel[i].width;
  });
};